var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

import React from 'react';
import Icon from '../../../../components/Icon';
import marked from 'marked';
import translate from '../../../../lib/utils/translate';

/**
 * Single bonus item
 * @param {string} Name - name/title of the bonus
 * @param {function} onClick - eventhandler passed as props to onClick
 * @param {object} content - Content object contains data from contentful and is undefined if no Bonus in contentful for given name is provided
 */
var Bonus = function Bonus(_ref) {
  var Name = _ref.Name,
      onClick = _ref.onClick,
      content = _ref.content;
  return React.createElement(
    'div',
    { className: 'Bonus', onClick: onClick },
    content && content.content ? React.createElement('div', {
      className: 'bonus-content',
      dangerouslySetInnerHTML: { __html: marked(content.content) }
    }) : React.createElement(
      'span',
      null,
      Name
    ),
    React.createElement(Icon, { icon: 'chevron-right' })
  );
};

/**
 * Returns a list of available bonuses
 * @param {array} bonuses array of objects containing bonuses
 * @param {object} intl translation object used for translating string values
 * @param {function} onSelect function invoked with promotion code passed in as argument
 */
var Bonuses = function Bonuses(_ref2) {
  var bonuses = _ref2.bonuses,
      intl = _ref2.intl,
      onSelect = _ref2.onSelect;
  return React.createElement(
    'div',
    { className: 'Bonuses' },
    bonuses && bonuses.map(function (b, k) {
      return React.createElement(Bonus, _extends({ key: k }, b, { onClick: function onClick() {
          return onSelect(b.PromoCode);
        } }));
    }),
    React.createElement(Bonus, {
      Name: translate({ id: 'label.no_bonus' }, intl),
      onClick: function onClick() {
        return onSelect('');
      }
    })
  );
};

export default Bonuses;